// extracted by mini-css-extract-plugin
module.exports = {"mark":"DobiNavigationMark_mark__0nyYt"};